exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".requests-page {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n.requests-page__info {\n  display: flex;\n  justify-content: center;\n  padding: 32px;\n  font-size: 32px;\n}\n.requests-page__content {\n  display: flex;\n  flex-direction: column;\n  width: 80vw;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Requests/containers/Requests.less
// module id = 1175
// module chunks = 0